import { isNil, isNull } from 'lodash';

export const getSlaInformationListSearchBody = (customerVendorId, productVendorId) => {
  return {
    intent: '',
    fields: [
      'VendorSlaResponseId',
      'VendorOrgId',
      'CustomerVendorId',
      'CustomerVendorProductId',
      'ProductVendorId',
      'SlaStatementId',
      'IncidentSlaSectionId',
      'SlaText',
      'Indent',
      'DisplayOrder',
      'IncidentSlaSectionId',
      'TimeOffsetText',
      'ResponseTimeUnit',
      'ResponseEventText',
      'RequiresDocument',
      'QuestionResponseType',
      'QuestionResponseCategory',
      'QuestionResponseText',
      'ParentSlaStatementId',
      'ResponseCategoryId',
    ],
    criterion: [
      {
        field: 'CustomerVendorId',
        operator: isNil(customerVendorId) ? 'isnull' : '=',
        value: isNil(customerVendorId) ? '' : customerVendorId,
      },
      {
        field: 'ProductVendorId',
        operator: isNil(productVendorId) ? 'isnull' : '=',
        value: isNil(productVendorId) ? '' : productVendorId,
      },
    ],
    sort: [
      {
        field: 'DisplayOrder',
        order: 'ASC',
      },
    ],
    page: 0,
    pageSize: 0,
  };
};

export const getSlaStatementListSearchBody = () => {
  return {
    intent: '',
    fields: [
      'SlaStatementId',
      'IncidentSlaSectionId',
      'SlaText',
      'Indent',
      'DisplayOrder',
      'IncidentSlaSectionId',
      'TimeOffsetText',
      'ResponseTimeUnit',
      'ResponseEventText',
      'RequiresDocument',
      'QuestionResponseType',
      'ParentSlaStatementId',
      'ResponseCategoryId',
    ],
    criterion: [],
    sort: [
      {
        field: 'DisplayOrder',
        order: 'ASC',
      },
    ],
    page: 0,
    pageSize: 0,
  };
};
